import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import "./style.css";

const LoadingBar = () => {
  const { t } = useTranslation();

  const isLoading = useSelector(state => state.ui.status.isLoading);

  if (!isLoading) return null;

  return <div className="loading-bar">{t("generic:loading")}</div>;
};

export default LoadingBar;
